import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { DollarSign, PremiumIcon } from '@calendly/ui/components/icons';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import { useGetUserQuery } from 'common';
import { BILLING_ENTRYPOINTS, moveToChangeSubscription, NOTETAKER_FREE_MEETINGS_PAYWALL_FEATURE, setAnalyticsLocation } from 'features/billing';
import { useGetNotetakerFreeMeetingsQuotaQuery, useGetMeetingIntelligenceUserSettingsQuery } from 'features/meeting_intelligence/api';
import { useEnableNotetakerWithLoader } from 'features/meeting_intelligence/hooks';
import { useNotetakerFiveFreeRecapsExperiment } from 'hooks/useNotetakerFiveFreeRecapsExperiment';
import { normalizeRecapsUsage } from './helpers';
const bannerCss = "b1uoaekp";
const upgradeButtonCss = "uy53nnn";
const bannerButtonOverrideCss = "bm6v3bq";
const Banner = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(bannerCss, bannerButtonOverrideCss, props.className)} />;
});
const textContentCss = "tp40qp4";
const TextContent = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(textContentCss, props.className)} />;
});
const UpgradeButton = forwardRef((props, ref) => <Button ref={ref} {...props} className={classNames(upgradeButtonCss, props.className)} />);
export const FreeRecapsInlineBanner = () => {
  const dispatch = useDispatch();
  const enableNotetaker = useEnableNotetakerWithLoader();
  const {
    isInExperiment
  } = useNotetakerFiveFreeRecapsExperiment();
  const {
    data: userData
  } = useGetUserQuery();
  const {
    data: featureAvailability,
    isLoading,
    error
  } = useGetNotetakerFreeMeetingsQuotaQuery({
    userUuid: userData?.uuid
  }, {
    skip: !isInExperiment || !userData?.uuid
  });
  const featureAvailabilityDetails = featureAvailability?.resource?.details;
  const featureAvailable = featureAvailability?.resource?.featureAvailable;
  const {
    data: meetingIntelligenceData
  } = useGetMeetingIntelligenceUserSettingsQuery(undefined, {
    skip: !isInExperiment || !userData?.uuid
  });
  const isMiEnabled = meetingIntelligenceData?.miEnabled;
  const handleUpgrade = () => {
    dispatch(setAnalyticsLocation(BILLING_ENTRYPOINTS.RECAPS_DETAIL_PAGE));
    dispatch(moveToChangeSubscription({
      featureKey: 'meeting_intelligence',
      preface: true,
      quotaAnalytics: {
        name: NOTETAKER_FREE_MEETINGS_PAYWALL_FEATURE,
        ...(featureAvailable !== undefined && {
          quotaReached: !featureAvailable
        })
      },
      ...(isMiEnabled === false && {
        onSuccess: enableNotetaker
      })
    }));
  };
  if (!isInExperiment) {
    return null;
  }
  if (isLoading || error) {
    return null;
  }
  if (!featureAvailabilityDetails) {
    return null;
  }
  const normalized = normalizeRecapsUsage(featureAvailabilityDetails);
  if (!normalized) {
    return null;
  }
  const {
    usedRecaps,
    recapsQuota
  } = normalized;
  return <Banner>
      <TextContent>
        <DollarSign size="standard" />
        <BodyText>
          {HtmlParser(I18n.t('publisher.meeting_intelligence.free_recaps.usage', {
          used: usedRecaps,
          total: recapsQuota
        }))}
        </BodyText>
      </TextContent>
      <UpgradeButton decoration="secondary-outline" responsive={false} onClick={handleUpgrade}>
        <PremiumIcon size="standard" />
        {I18n.t('publisher.meeting_intelligence.free_recaps.upgrade_button')}
      </UpgradeButton>
    </Banner>;
};

require("./free_recaps_inline_banner.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./free_recaps_inline_banner.js");